<template>
  <div class="themed-bg min-h-screen p-4 pb-20">
    <!-- Header with theme toggle -->
    <div class="flex justify-between items-center mb-4">
      <div>
        <h2 class="text-2xl font-bold">Welcome, Yutthana!</h2>
        <p class="themed-text-secondary">Kasetgeny9 - Manufacturer Account</p>
      </div>
      <ThemeToggle />
    </div>

    <!-- Welcome Header -->
    <div class="glass-card p-6 mb-4">
      <div class="grid grid-cols-2 gap-4">
        <div class="text-center">
          <p class="text-3xl font-bold text-accent">12</p>
          <p class="text-sm themed-text-secondary">Active Devices</p>
        </div>
        <div class="text-center">
          <p class="text-3xl font-bold text-accent">3,450</p>
          <p class="text-sm themed-text-secondary">Total Hectares</p>
        </div>
      </div>
    </div>

    <!-- Quick Stats -->
    <div class="grid grid-cols-2 gap-3 mb-4">
      <div class="glass-card p-4 hover-lift">
        <div class="flex items-center justify-between mb-2">
          <span class="text-2xl">🚁</span>
          <span class="pulse-dot"></span>
        </div>
        <p class="text-xl font-semibold">8</p>
        <p class="text-xs themed-text-secondary">Flying Now</p>
      </div>
      
      <div class="glass-card p-4 hover-lift">
        <div class="flex items-center justify-between mb-2">
          <span class="text-2xl">📋</span>
          <span class="badge badge-primary">Today</span>
        </div>
        <p class="text-xl font-semibold">24</p>
        <p class="text-xs themed-text-secondary">Tasks Today</p>
      </div>
      
      <div class="glass-card p-4 hover-lift">
        <div class="flex items-center justify-between mb-2">
          <span class="text-2xl">⚠️</span>
          <span class="badge badge-warning">Alert</span>
        </div>
        <p class="text-xl font-semibold">2</p>
        <p class="text-xs themed-text-secondary">Maintenance</p>
      </div>
      
      <div class="glass-card p-4 hover-lift">
        <div class="flex items-center justify-between mb-2">
          <span class="text-2xl">👥</span>
          <span class="badge badge-success">Team</span>
        </div>
        <p class="text-xl font-semibold">15</p>
        <p class="text-xs themed-text-secondary">Operators</p>
      </div>
    </div>

    <!-- Mock Field Map -->
    <MockFieldMap class="mb-4" />

    <!-- Inspired Data Cards -->
    <InspiredDataCards class="mb-4" />

    <!-- Activity Feed -->
    <ActivityFeed class="mb-4" />

    <!-- Quick Actions -->
    <div class="grid grid-cols-2 gap-3 mb-4">
      <button class="accent-btn hover-lift">
        <span class="text-xl mb-1">➕</span>
        <span class="text-sm font-medium">New Task</span>
      </button>
      
      <button class="accent-btn hover-lift">
        <span class="text-xl mb-1">🚁</span>
        <span class="text-sm font-medium">Deploy Drone</span>
      </button>
      
      <button class="accent-btn hover-lift">
        <span class="text-xl mb-1">📊</span>
        <span class="text-sm font-medium">Reports</span>
      </button>
      
      <button class="accent-btn hover-lift">
        <span class="text-xl mb-1">🗺️</span>
        <span class="text-sm font-medium">Field Map</span>
      </button>
    </div>

    <!-- Neon Diagram Demo -->
    <div class="neon-box rounded-xl p-4 mb-4">
      <h3 class="neon-text text-lg font-bold mb-3">System Status</h3>
      <div class="neon-grid rounded-lg p-3 border border-cyan-500/30">
        <div class="grid grid-cols-3 gap-2 text-center">
          <div class="neon-border rounded p-2">
            <span class="neon-text text-xs">CPU</span>
            <p class="text-white font-bold">42%</p>
          </div>
          <div class="neon-border rounded p-2">
            <span class="neon-text text-xs">NET</span>
            <p class="text-white font-bold">↑12ms</p>
          </div>
          <div class="neon-border rounded p-2">
            <span class="neon-text text-xs">UPTIME</span>
            <p class="text-white font-bold">99.9%</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Floating Action Button -->
    <FloatingActionButton />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ThemeToggle from '@/components/ThemeToggle.vue'
import MockFieldMap from '@/components/MockFieldMap.vue'
import InspiredDataCards from '@/components/InspiredDataCards.vue'
import ActivityFeed from '@/components/ActivityFeed.vue'
import FloatingActionButton from '@/components/FloatingActionButton.vue'

onMounted(() => {
  // Initialize dashboard data
})
</script>
